import React from "react";

const ModalCloseIcon = (props: any) => {
  return (
    <button
      type="button"
      className="modal-close-hit"
      aria-label="Close"
      onClick={() => props?.closeModal?.()}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 9 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 1L1 8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 1L8 8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default ModalCloseIcon;
